export default __webpack_public_path__ + "static/media/Roxus_Icons_Individual_Tick.8c2b3be8.png";